export const normalizeId = (id = '', addHash = false) => {
    const regex = new RegExp(/^[A-Za-z]+[\w\-:.]*$/);
    const valid = regex.test(id);
    if (new RegExp(/^\d/).test(id)) {
        id = `ID_${id}`;
    }
    const validId = valid ? id : id.replace(/\W/g, '_');
    return addHash ? `#${validId}` : validId;
};
